import SinglePeriodAppointments from "./SinglePeriodAppointments";

const PickAppointment = () => {
  const appointmentsPeriods = {
    name: "appointments",
    periods: [
      {
        period: "Morning",
        appointments: [
          {
            id: 1,
            from: "10:30AM",
            to: "11:00PM",
          },
          {
            id: 2,
            from: "10:30AM",
            to: "11:00PM",
          },
          {
            id: 3,
            from: "10:30AM",
            to: "11:00PM",
          },
        ],
      },
      {
        period: "Eventing",

        appointments: [
          {
            id: 4,
            from: "10:30AM",
            to: "11:00PM",
          },
          {
            id: 5,
            from: "10:30AM",
            to: "11:00PM",
          },
          {
            id: 6,
            from: "10:30AM",
            to: "11:00PM",
          },
        ],
      },
    ],
  };
  return (
    <div className="m-2">
      <div className="periods-of-day">
        <form action="#" onSubmit={(event) => event.preventDefault()}>
          {appointmentsPeriods.periods.map((period, index) => {
            return (
              <SinglePeriodAppointments
                name={appointmentsPeriods.name}
                period={period.period}
                appointments={period.appointments}
                key={index}
              />
            );
          })}
        </form>
      </div>
    </div>
  );
};

export default PickAppointment;
